module.exports = __webpack_public_path__ + "static/media/je.2a23e6c1.svg";